// extracted by mini-css-extract-plugin
module.exports = {"root":"IntervalStatusIcon_root__VWqka","dotIcon":"IntervalStatusIcon_dotIcon__3hvko"};